import type React from "react";
import { ContentContainerWrapper } from "~/components/ContentContainer";
import { DefaultLayout } from "~/components/Layout";

export const Loading: React.FC = () => {
	return (
		<>
			<title>Login | TIER IV Account | TIER IV Account</title>
			<DefaultLayout>
				<ContentContainerWrapper>
					<div />
				</ContentContainerWrapper>
			</DefaultLayout>
		</>
	);
};
